export type Escopo = 'mercado' | 'tempo' | 'noticias' | 'portal' | 'indicadores' | 'esportes';
export const ESCOPOS: { value: Escopo; label: string }[] = [
  { value: 'mercado', label: 'Mercado e cripto' },
  { value: 'tempo', label: 'Tempo por capital' },
  { value: 'noticias', label: 'Notícias por termo e agro' },
  { value: 'portal', label: 'Publicações do portal' },
  { value: 'indicadores', label: 'Indicadores' },
  { value: 'esportes', label: 'Esportes (futebol brasileiro)' },
];

export interface Consumidor {
  id: string;
  nome: string;
  prefixo: string;
  ips_permitidos: string[];
  escopos: Escopo[];
  limite_por_minuto: number;
  chamadas_mes: number;
  ultimo_uso_em: string | null;
  ultimo_ip: string | null;
  criado_em: string | null;
  revogado_em: string | null;
}
export interface ConsumidorCreate {
  nome: string;
  ips_permitidos?: string[];
  escopos: Escopo[];
  limite_por_minuto: number;
}
export type ConsumidorUpdate = Partial<ConsumidorCreate>;
export interface ConsumidorCriado extends Consumidor {
  token: string;
}
export interface ConsumidorUso {
  chamadas_mes: number;
  mes: string | null;
  ultimo_uso_em: string | null;
  ultimo_ip: string | null;
  custo_serp_usd: number | null;
  custo_observacao: string;
}
